import React, { useEffect, useState } from 'react'
import useHttp from '../../../hooks/use-http';
import Input from "../../UI/Input";
import { endPoints } from "../../../config/end-points"
import { cuteToast } from '../../UI/cute';
import { FiCpu } from "react-icons/fi";

const AiKeys = () => {

    const {sendRequest: saveAiKeys} = useHttp();
    const {sendRequest: getSettingData} = useHttp();

    const [details, setDetails] = useState({
        openaiApiKey: "",
        geminiApiKey: "",
    });

    useEffect(()=>{
        getSettingData({
            url: endPoints.getSettingData,
            method: "GET",
        },(response)=>{
            if(response.status === 200 && response.body.length > 0){
                const result = response.body
                const aiData = result.filter((data)=>data.meta_type === "ai_api_keys");
                if(aiData.length > 0){
                    const meta_data = JSON.parse(aiData[0].meta_data)
                    if(meta_data){
                        setDetails(meta_data)
                    }
                }
            }
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const formHandler = (event) => {
        event.preventDefault();

        saveAiKeys({
            url: endPoints.updateSmtpDetails,
            method: "POST",
            body: {
                ...details,
                type:"ai_api_keys"
            },
        },(response)=>{
            if(response.status === 200){
                cuteToast({
                    type: "success",
                    message: "Saved Successfully.",
                    timer: 5000,
                    title: "AI API Keys",
                  });
            }
        })
    }

  return (
    <form onSubmit={formHandler}>
      <div className="st-form-card">
        <div className="st-card-head">
          <div className="st-card-head-icon st-icon-ai">
            <FiCpu size={19} />
          </div>
          <div>
            <h3 className="st-card-head-title">AI Provider Keys</h3>
            <p className="st-card-head-desc">Configure API keys for AI-powered content generation</p>
          </div>
        </div>

        <div className="st-card-body">
          <div className="st-form-row">
            <div className="st-form-group">
              <label className="st-label">OpenAI API Key</label>
              <div className="st-input-wrapper">
                <span className="st-input-icon"><FiCpu /></span>
                <Input
                  type="password"
                  inputClass="st-input st-input-with-icon"
                  value={details.openaiApiKey}
                  placeholder="sk-..."
                  onChange={(e) =>
                    setDetails({ ...details, openaiApiKey: e.target.value })
                  }
                />
              </div>
              <p className="st-helper-text">Required for AI-powered wireframing and generation</p>
            </div>
            <div className="st-form-group">
              <label className="st-label">Gemini API Key</label>
              <div className="st-input-wrapper">
                <span className="st-input-icon"><FiCpu /></span>
                <Input
                  type="password"
                  inputClass="st-input st-input-with-icon"
                  value={details.geminiApiKey}
                  placeholder="AIza..."
                  onChange={(e) =>
                    setDetails({ ...details, geminiApiKey: e.target.value })
                  }
                />
              </div>
              <p className="st-helper-text">Used as a fallback for high-traffic content creation</p>
            </div>
          </div>
        </div>

        <div className="st-card-foot">
          <button className="st-btn-primary" type="submit">Save Keys</button>
        </div>
      </div>
    </form>
  )
}

export default AiKeys
